import {
    getApiBarberShiftsAvailableSlotsQueryKey,
    getApiBarberShiftsBookedQueryKey,
    usePostApiBarberShiftBook,
} from '@barbershop/api/barber'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { FORMATTED_TODAY_DATE, FORMATTED_TOMORROW_DATE } from '../../model/constants'

const bookedShiftsBaseQueryKey = getApiBarberShiftsBookedQueryKey({ from: '', to: '' }).slice(0, 1)

type UseBookShiftOptions = Parameters<typeof usePostApiBarberShiftBook>[0]

export const useBookShift = (options: UseBookShiftOptions = {}) => {
    const queryClient = useQueryClient()
    const { mutation, ...apiOptions } = options

    const { mutateAsync: bookShift, isPending } = usePostApiBarberShiftBook({
        ...apiOptions,
        mutation: {
            ...mutation,
            onSuccess: async (...arguments_) => {
                await Promise.all([
                    queryClient.invalidateQueries({
                        queryKey: getApiBarberShiftsAvailableSlotsQueryKey({
                            from: FORMATTED_TODAY_DATE,
                            to: FORMATTED_TOMORROW_DATE,
                        }),
                    }),
                    queryClient.invalidateQueries({
                        queryKey: bookedShiftsBaseQueryKey,
                    }),
                ])

                if (mutation?.onSuccess) {
                    await mutation.onSuccess(...arguments_)

                    return
                }

                toast.success('Смена успешно забронирована')
            },
            onError: (...arguments_) => {
                if (mutation?.onError) {
                    mutation.onError(...arguments_)

                    return
                }

                toast.error('Ошибка при бронировании смены')
            },
        },
    })

    return {
        bookShift,
        isPending,
    }
}
